import React from 'react';
import Icon from '../../../components/AppIcon';

const FeatureCard = ({ icon, title, description, color = 'primary' }) => {
  const colorClasses = {
    primary: 'bg-primary/10 text-primary',
    secondary: 'bg-secondary/10 text-secondary',
    accent: 'bg-accent/10 text-accent',
    success: 'bg-success/10 text-success',
  };

  return (
    <div className="bg-card rounded-xl p-6 md:p-8 shadow-sm hover:shadow-md transition-organic hover-lift">
      <div className={`w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 ${colorClasses?.[color]} rounded-xl flex items-center justify-center mb-4 md:mb-6`}>
        <Icon name={icon} size={28} className="md:w-8 md:h-8 lg:w-9 lg:h-9" />
      </div>
      <h3 className="text-lg md:text-xl lg:text-2xl font-semibold text-foreground mb-3 md:mb-4">
        {title}
      </h3>
      <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
        {description}
      </p>
    </div>
  );
};

export default FeatureCard;